// extracted by mini-css-extract-plugin
export default {"leaders":"leaders_leaders__aszh-"};